import api, { type RequestBody, multipart } from ".";
import type { PaginatedList } from "src/types/api";
import type { ProductRow, StockRequestDetail, StockRequestRow } from "src/types/inventory";

/** Query accepted by the product list endpoints. */
export interface ProductQuery {
	page?: number;
	limit?: number;
	search?: string;
	/** Store/warehouse uuid to scope the list to. */
	entity?: string;
	store_or_warehouse_uuid?: string;
}

export const getInventory = (params?: ProductQuery) => api.get<PaginatedList<ProductRow>>("/products", { params });

export const getArchivedInventory = (params?: ProductQuery) => api.get<PaginatedList<ProductRow>>("/products/archived", { params });

export const archiveInventory = ({ uuid }: { uuid: string }) => api.patch(`/products/${uuid}/archive`);

export const unarchiveInventory = ({ uuid }: { uuid: string }) => api.patch(`/products/${uuid}/unarchive`);

export const editProduct = ({ uuid, ...data }: { uuid: string } & RequestBody) => api.post(`/products/${uuid}`, data, multipart);

export const addProduct = (data: RequestBody) => api.post<ProductRow>("/products/store", data, multipart);

export const addBulkProduct = (data: FormData) => api.post("/products/add-bulk", data, multipart);

export const getInventoryLogs = <T = unknown>(params?: Record<string, unknown>) => api.get<PaginatedList<T>>("/inventories/logs", { params });

export const getIncomingRequest = (params?: Record<string, unknown>) =>
	api.get<PaginatedList<StockRequestRow>>("/inventories/incoming-requests", { params });

export const getOutgoingRequest = (params?: Record<string, unknown>) =>
	api.get<PaginatedList<StockRequestRow>>("/inventories/outgoing-requests", { params });

export const createRequest = (data: RequestBody) => api.post("/inventories/request-product", data);

export const getRequest = (uuid: string) => api.get<StockRequestDetail>(`/inventories/requests/${uuid}`);

export const approveRequest = ({ uuid, ...data }: { uuid: string } & RequestBody) =>
	api.post(`/inventories/requests/${uuid}/approve`, data);

export const updateInventory = (data: RequestBody) => api.post("inventories", data);
